define([
    './WizardFlowService',
    'edge/platform/widgets/modal/module',
    'angularRouter',
    'edge/platform/util/module',
    'l10nModule'
], (WizardFlowService)=> {
    return angular.module('edge.platform.flow', [
            'edge.platform.widgets.modal',
            'ui.router',
            'edge.platform.util',
            'edge.platform.l10n'
        ])
        .factory('WizardFlowService', WizardFlowService);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/flow/module.js
 **/